import { useEffect, useState } from "react";

const config = {
  STREAM_DURATION: 2000,
  INTERVAL: 10,
  SPAWN_AREA_WIDTH_PERCENT: 1,
  MIN_FALL_DURATION: 200,
  MAX_FALL_DURATION: 2000,
  COLORS: ["#EF2964", "#00C09D", "#2D87B0", "#48485E", "#EFFF1D"],
};

interface ConfettiPiece {
  id: number;
  style: React.CSSProperties;
}

const createConfettiPiece = (): ConfettiPiece => {
  const newId = Date.now() + Math.random();

  const spawnAreaWidth = window.innerWidth * config.SPAWN_AREA_WIDTH_PERCENT;
  const spawnAreaOffset = (window.innerWidth - spawnAreaWidth) / 2;
  const startX = spawnAreaOffset + Math.random() * spawnAreaWidth;
  const endX = startX + (Math.random() - 0.5) * 200;

  const startRotate = (Math.random() - 0.5) * 360;
  const endRotate = (Math.random() - 0.5) * 720 + startRotate;

  const color = config.COLORS[Math.floor(Math.random() * config.COLORS.length)];

  const duration =
    Math.random() * (config.MAX_FALL_DURATION - config.MIN_FALL_DURATION) +
    config.MIN_FALL_DURATION;

  const topX2 = Math.random() * 100;
  const bottomX1 = Math.random() * 100;
  const clipPath = `polygon(0% 0%, ${topX2}% 0%, ${bottomX1}% 100%, 0% 100%)`;

  return {
    id: newId,
    style: {
      backgroundColor: color,
      clipPath: clipPath,
      "--start-x": `${startX}px`,
      "--end-x": `${endX}px`,
      "--start-rotate": `${startRotate}deg`,
      "--end-rotate": `${endRotate}deg`,
      animationDuration: `${duration}ms`,
    },
  };
};

export const useConfetti = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [pieces, setPieces] = useState<ConfettiPiece[]>([]);

  useEffect(() => {
    setIsAnimating(true);
    const animationTimer = setTimeout(
      () => setIsAnimating(false),
      config.STREAM_DURATION,
    );
    return () => clearTimeout(animationTimer);
  }, []);

  useEffect(() => {
    if (!isAnimating) return;

    const streamInterval = setInterval(() => {
      const newPiece = createConfettiPiece();

      setPieces((current) => [...current, newPiece]);

      const pieceDuration = parseFloat(
        newPiece.style.animationDuration as string,
      );
      setTimeout(() => {
        setPieces((current) => current.filter((p) => p.id !== newPiece.id));
      }, pieceDuration + 100);
    }, config.INTERVAL);

    return () => clearInterval(streamInterval);
  }, [isAnimating]);

  return pieces;
};
